import React, { useEffect, useState } from "react";
import InputField from "../../../library/components/InputField";
import { Validators } from "../../../library/utilities/Validator";
import CaptchaPage from "../../captcha/captchaPage1";
import captcha from "../../../images/captcha.svg";
import eclipse from "../../../images/eclipse.svg";
import vector from "../../../images/vector.svg";
import "../login.css";
import Button from "../../../library/components/Button";
import { Link, useLocation } from "react-router-dom";
import PasswordField from "../../../library/components/Password";
import EciLogin from './EciLogin'
import ServiceVoterLogin from './ServiceVotersLogin'
import { UnderLine } from '../../../ui'
import { LOGIN_USER_TYPE_SERVICE_VOTER,LOGIN_USER_TYPE_ECI_OFFICIAL } from '../../../constants/constants'

function LoginForm({
  loginObj,
  setUserType,
  // userType,
  setLoginObj,
  exceedError,
  resetPassword,
  Error,
  setError,
  captchaId,
  setCaptchaId,
  errorData,
  setErrorData,
  captchaData,
  setCaptchaArg,
  captchaArg,
}) {
  // if (!userType || userType === undefined) {
  //   userType = LOGIN_USER_TYPE_ECI_OFFICIAL;
  // }
  const [captchaButton, setCaptchaButton] = useState(true);
  const [Change, setChange] = useState(false)
  const [buttoneDis, setbuttoneDis] = useState(true)
 

  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };
  // const enableSidebar = () => {
  //   props.clickNext();
  // };
  const location = useLocation();
  // const state = location.state;

  // const exceedError = state ? state.exceed : null;

  // const resetPassword = state ? state.reset : null;

  const handleChange = (key, event) => {
    if (captchaButton === false) {
      setChange(true)
    }
    setLoginObj({ ...loginObj, [key]: event });

  };

  useEffect(() => {
    if (captchaButton === false && Change === true) {
      setCaptchaButton(true)
      setChange(false)
    }
    if (Change === true) {
      setChange(false)
    }
  }, [Change])

  // const renderTabs = () => {
  //   switch (userType) {
  //     case LOGIN_USER_TYPE_SERVICE_VOTER:
  //       return (
  //         <ServiceVoterLogin
  //           loginObj={loginObj}
  //           setLoginObj={setLoginObj}
  //           setError={setError}
  //           Error={Error}
  //           exceedError={exceedError}
  //           resetPassword={resetPassword}
  //           // captchaVerify={isCaptchaVerify}
  //           formname={LOGIN_USER_TYPE_SERVICE_VOTER}
  //           captchaId={captchaId}
  //           setCaptchaId={setCaptchaId}
  //           errorData={errorData}
  //           setErrorData={setErrorData}
  //           captchaData={captchaData}
  //           setCaptchaArg={setCaptchaArg}
  //           captchaArg={captchaArg}
  //         />
  //       )
  //     case LOGIN_USER_TYPE_ECI_OFFICIAL:
  //       return (
  //         <EciLogin
  //           loginObj={loginObj}
  //           setLoginObj={setLoginObj}
  //           setError={setError}
  //           Error={Error}
  //           exceedError={exceedError}
  //           resetPassword={resetPassword}
  //           // captchaVerify={isCaptchaVerify}
  //           formname={LOGIN_USER_TYPE_ECI_OFFICIAL}
  //           captchaId={captchaId}
  //           setCaptchaId={setCaptchaId}
  //           errorData={errorData}
  //           setErrorData={setErrorData}
  //           captchaData={captchaData}
  //           setCaptchaArg={setCaptchaArg}
  //           captchaArg={captchaArg}
  //         />
  //       )
  //     default:
  //       return (
  //         <EciLogin
  //           loginObj={loginObj}
  //           setLoginObj={setLoginObj}
  //           setError={setError}
  //           Error={Error}
  //           exceedError={exceedError}
  //           resetPassword={resetPassword}
  //           captchaId={captchaId}
  //           setCaptchaId={setCaptchaId}
  //           errorData={errorData}
  //           setErrorData={setErrorData}
  //           captchaData={captchaData}
  //           setCaptchaArg={setCaptchaArg}
  //           captchaArg={captchaArg}
  //           // captchaVerify={isCaptchaVerify}
  //         />
  //       )
  //   }
  // }


  return (
    <div className="mr-2">
      <div className="col-sm-12 heading_login text-center">
          <h4 className="heading_login_title">Login For ECINet</h4>
          <p className="heading_login_subtitle">To Get Sign In To Account</p>


          {/* <p>Do not have an account? <Link to="/signUp">Sign-Up</Link></p> */}
        </div>
   

      <EciLogin
            loginObj={loginObj}
            setLoginObj={setLoginObj}
            setError={setError}
            Error={Error}
            exceedError={exceedError}
            resetPassword={resetPassword}
            // captchaVerify={isCaptchaVerify}
            formname={LOGIN_USER_TYPE_ECI_OFFICIAL}
            captchaId={captchaId}
            setCaptchaId={setCaptchaId}
            errorData={errorData}
            setErrorData={setErrorData}
            captchaData={captchaData}
            setCaptchaArg={setCaptchaArg}
            captchaArg={captchaArg}
          />

      {/* <div className="row px-2 pt-1 pb-4 captcha_wrap">
        <div className="col-sm-6">
          <div className="captcha-image">
            <img id="image" src={captcha} alt={captcha} />
            <img id="eclipse" src={eclipse} alt={eclipse} />
            <img id="vector" src={vector} alt={vector} />
          </div>

        </div>

        <div className="col-sm-6">
          <div className="row">
            <InputField
              label="Captcha"
              name="captcha"
              labelClass="col-md-12"
              inputClass="col-md-12 input"
              placeholder="Captcha"
              value={loginObj.captcha}
              type="text"
              required={true}
              onChange={(val) => handleChange("captcha", val)}
              validators={[
                {
                  check: Validators.required,
                  message: "this field is required",
                },
              ]}
            />
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default LoginForm
